import type { RouteRecordRaw } from 'vue-router'

import { ensureRootRoutePath, type RedirectRoutePath } from '@/utilities/routers'

const routeUnsubscribeName = '/unsubscribe'
const routeUnsubscribePath = ensureRootRoutePath(routeUnsubscribeName)

const routeUnsubscribe: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/views/UnsubscribeView.vue')
  },
  meta: {
    requireAuth: false,
  },
  name: routeUnsubscribeName,
  path: routeUnsubscribePath,
}

const redirectUnsubscribe: RedirectRoutePath = {
  // use no "name" attribute here, not working with global navigationGuard
  path: routeUnsubscribe.path,
}

export { redirectUnsubscribe, routeUnsubscribe }
